export const capitalizeFirstLetter = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1)
}

export const capitalizeText = (text: string = "") => {
  if (!text) return ""

  return text
    .split(" ")
    .map((it) => capitalizeFirstLetter(it))
    .join(" ")
}
